import React, { useEffect } from 'react'
import {Routes, Route, Navigate, useLocation} from 'react-router-dom'
import './css/App.css'
import './css/Button.css'
import moment from 'moment'
import 'moment/locale/ru'

if (typeof window !== 'undefined') {
    window.moment = moment
    window.moment.locale('ru')
}

// tech
import Logout from "./pages/Logout"
import Login from "./pages/Login"
import Recovery from "./pages/Recovery.jsx"

// company
import EditCompany from "./pages/EditCompany"
import UserManagement from "./pages/UserManagement"
import UserAdd from "./pages/UserAdd"

// self
import Personal from "./pages/Personal"
import ChangePasswordForm from "./pages/ChangePasswordForm"

// subs
import SubscriptionsList from "./pages/SubscriptionsList"
import Reports from "./pages/Reports"
import SubscriptionAdd from "./pages/SubscriptionAdd"

function usePageTitle() {
    const location = useLocation()

    useEffect(() => {
        const path = location.pathname
        let dlpName = 'Billing Back Office'

        if (path === '/logout') {dlpName += ' → Выход'}
        else if (path === '/login') {dlpName += ' → Вход'}
        else if (path === '/panel/company/editcompany') {dlpName += ' → Редактирование Компании'}
        else if (path === '/panel/company/usersmanegment') {dlpName += ' → Редактирование Пользователя'}
        else if (path === '/panel/adduser') {dlpName += ' → Добавить Пользователя'}
        else if (path === '/panel/personal') {dlpName += ' → Данные пользователя'}
        else if (path === '/panel/changepasswordform') {dlpName += ' → Сменить пароль'}
        else if (path === '/backoffice/subscriptions') {dlpName += ' → Подписки'}
        else if (path === '/reports/index') {dlpName += ' → Отчёты'}
        else if (path === '/backoffice/editsubscription/returl/backoffice/subscriptions') {dlpName += ' → Выбор продукта'}

        document.title = dlpName;

        // Установка класса для фона на странице логина
        if (path === '/login') {
            document.body.classList.add('login-background');
        } else {
            document.body.classList.remove('login-background');
        }
    }, [location])
}

const ProtectedRoute = ({ children }) => {
    const location = useLocation()
    const isAuth = !!localStorage.getItem('authData')

    if (!isAuth) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }
    return children
}

function App() {
    usePageTitle()

    return (
        <Routes>
            <Route path="/logout" element={<Logout />} />
            <Route path="/login" element={<Login />} />
            <Route path="/panel/recoverypassword" element={<Recovery />} />

            <Route path="/panel/company/editcompany" element={<ProtectedRoute><EditCompany /></ProtectedRoute>}/>
            <Route path="/panel/company/usersmanegment" element={<ProtectedRoute><UserManagement /></ProtectedRoute>}/>
            <Route path="/panel/adduser" element={<ProtectedRoute><UserAdd /></ProtectedRoute>}/>

            <Route path="/panel/personal" element={<ProtectedRoute><Personal /></ProtectedRoute>}/>
            <Route path="/panel/changepasswordform" element={<ProtectedRoute><ChangePasswordForm /></ProtectedRoute>}/>

            <Route path="/backoffice/subscriptions" element={<ProtectedRoute><SubscriptionsList /></ProtectedRoute>}/>
            <Route path="/reports/index" element={<ProtectedRoute><Reports /></ProtectedRoute>}/>
            <Route path="/backoffice/editsubscription/returl/backoffice/subscriptions" element={<ProtectedRoute><SubscriptionAdd /></ProtectedRoute>}/>

            <Route path="/*" element={<ProtectedRoute><SubscriptionsList /></ProtectedRoute>} />
        </Routes>
    )
}

export default App